const ID = 'radio';

export default ID;
